import $ from '../$';
import each from '../functions/each';
import unique from '../functions/unique';
import { JQ } from '../JQ';
import { isElement } from '../utils';
import './each';
import './is';
$.fn.children = function (selector) {
    const children = [];
    this.each((_, element) => {
        each(element.childNodes, (__, childNode) => {
            if (!isElement(childNode)) {
                return;
            }
            if (!selector || $(childNode).is(selector)) {
                children.push(childNode);
            }
        });
    });
    return new JQ(unique(children));
};
